import React from "react";

export default function About() {
    return (
        <section
            id="about"
            className="relative border-b border-hairline bg-oat py-24 lg:py-36"
            data-testid="about-section"
        >
            <div className="mx-auto max-w-[1400px] px-5 lg:px-10">
                <div className="grid gap-12 lg:grid-cols-12 lg:gap-16">
                    <div className="lg:col-span-5">
                        <div className="relative">
                            <div className="grid aspect-[4/5] place-items-center overflow-hidden border-2 border-ink bg-sage p-10">
                                <div className="text-center">
                                    <div className="font-serif text-5xl italic text-coral lg:text-6xl">
                                        Hi, we&apos;re
                                    </div>
                                    <div className="mt-3 font-display text-5xl font-black uppercase leading-[0.9] tracking-tight text-ink lg:text-7xl">
                                        Simple
                                        <br />
                                        Digital.
                                    </div>
                                    <div className="mt-6 inline-block border-2 border-ink bg-sun px-3 py-1 font-display text-xs font-black uppercase tracking-widest text-ink">
                                        Est. 2021 · Auckland
                                    </div>
                                </div>
                            </div>
                            <div className="absolute -bottom-4 -right-4 hidden border-2 border-ink bg-coral px-4 py-3 font-display text-xs font-black uppercase tracking-widest text-ink lg:block">
                                Made in Aotearoa
                            </div>
                        </div>
                    </div>

                    <div className="lg:col-span-7">
                        <div className="mb-4 text-xs font-bold uppercase tracking-[0.3em] text-coral">
                            // Chapter 07 · The crew
                        </div>
                        <h2 className="font-display text-5xl font-black leading-[0.95] tracking-tight text-ink sm:text-6xl lg:text-7xl">
                            For the small &amp;{" "}
                            <span className="font-serif italic font-normal text-coral">
                                the scrappy.
                            </span>
                        </h2>

                        <div className="mt-8 grid gap-6 text-base leading-relaxed text-ink/70 lg:text-lg">
                            <p>
                                Simple Digital is a small crew built specifically for small
                                business owners across Aotearoa and Australia. Cafés, retailers,
                                salons, coaches, trades, makers — anyone with 1–50 staff and not
                                much patience for agency theatre.
                            </p>
                            <p>
                                We charge fairly because we know what a tight month feels like. We
                                use plain English because jargon is just gatekeeping. And we
                                publish real numbers because trust is everything.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
